import { BASE_URL, TypefaceEmbedIDP, TypefaceEmbedOutputFormat, TypefaceEmbedUseCase } from "./model";
var VERSION = '0.6.11';
var getRedirectUrlByUseCase = function (sourceApp, applyButtonName, cancelButtonName, useCase, parameter, outputFormat, authProvider, hideHeader, styles) {
    var _a, _b, _c;
    var searchParams = new URLSearchParams();
    if (sourceApp) {
        searchParams.append("sourceApp", sourceApp);
    }
    searchParams.append("applyButtonName", applyButtonName);
    searchParams.append("cancelButtonName", cancelButtonName);
    searchParams.append("outputFormat", outputFormat);
    searchParams.append("embedBy", "web");
    searchParams.append("hideHeader", hideHeader ? 'true' : 'false');
    searchParams.append('showAccountSwitcher', styles.showAccountSwitcher ? 'true' : 'false');
    if (styles.embedFooterStyle) {
        searchParams.append("embedFooterStyle", JSON.stringify(styles.embedFooterStyle));
    }
    var queryParams = new URLSearchParams();
    if (sourceApp) {
        // add source app to both query params and redirect url, as it's needed in query param for sign in and in redirect
        // url for other logics
        queryParams.append("sourceApp", sourceApp);
    }
    switch (useCase) {
        case TypefaceEmbedUseCase.Default:
            var params_1 = parameter;
            Object.keys(params_1).forEach(function (key) {
                searchParams.set(key, JSON.stringify(params_1[key]));
            });
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/landing?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.JobPost:
            var jdParams = parameter;
            searchParams.append("templateParams", JSON.stringify(jdParams.parameters));
            if (jdParams.autoGenerate) {
                searchParams.append("templateAutoGenerate", JSON.stringify(jdParams.autoGenerate));
            }
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/template/").concat(jdParams.template, "?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.AIInsights:
            searchParams.append("useCase", "AIInsights");
            searchParams.append("parameters", JSON.stringify(parameter));
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/canvas?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.Template:
            var templateParameters = parameter;
            if (templateParameters === null || templateParameters === void 0 ? void 0 : templateParameters.parameters) {
                searchParams.append("templateParams", JSON.stringify(templateParameters.parameters));
            }
            if (templateParameters === null || templateParameters === void 0 ? void 0 : templateParameters.autoGenerate) {
                searchParams.append("templateAutoGenerate", JSON.stringify(templateParameters === null || templateParameters === void 0 ? void 0 : templateParameters.autoGenerate));
            }
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/template").concat((templateParameters === null || templateParameters === void 0 ? void 0 : templateParameters.template) ? "/".concat(templateParameters.template) : '', "?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.Text:
        case TypefaceEmbedUseCase.Image:
            var imageParameter = parameter;
            searchParams.append("blockType", useCase === TypefaceEmbedUseCase.Text ? "Text" : "Image");
            searchParams.append("promptText", imageParameter.prompt || '');
            searchParams.append("width", ((_a = imageParameter.width) === null || _a === void 0 ? void 0 : _a.toString()) || '');
            searchParams.append("height", ((_b = imageParameter.height) === null || _b === void 0 ? void 0 : _b.toString()) || '');
            searchParams.append("documentId", ((_c = imageParameter.documentId) === null || _c === void 0 ? void 0 : _c.toString()) || '');
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/image?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.TPIChat:
            searchParams.append("useCase", "TPIChat");
            searchParams.append("parameters", JSON.stringify(parameter));
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/chat?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        case TypefaceEmbedUseCase.ChooseDocument:
            searchParams.append("chooseProject", "true");
            queryParams.set("redirectUrl", "/embed/".concat(VERSION, "/canvas?").concat(searchParams.toString()));
            queryParams.set("authProvider", "".concat(authProvider));
            return "/embed/login?".concat(queryParams.toString());
        default:
            return '';
    }
};
export var getEmbedUrl = function (embedIdp, useCase, signOnUrl, typefaceOrigin, sourceApp, applyButtonName, cancelButtonName, parameter, outputFormat, authProvider, hideHeader, styles) {
    var redirectUrl = getRedirectUrlByUseCase(sourceApp, applyButtonName || 'Save', cancelButtonName || 'Cancel', useCase, parameter || {}, outputFormat || TypefaceEmbedOutputFormat.HTML, authProvider, hideHeader, styles || {});
    if (embedIdp === TypefaceEmbedIDP.Typeface) {
        return "".concat(typefaceOrigin || BASE_URL).concat(redirectUrl);
    }
    if (embedIdp === TypefaceEmbedIDP.Okta) {
        var searchParams = new URLSearchParams();
        searchParams.append("RelayState", encodeURIComponent("SAML:".concat(redirectUrl)));
        return "".concat(signOnUrl, "?").concat(searchParams.toString());
    }
    return "".concat(typefaceOrigin || BASE_URL).concat(redirectUrl);
};
export var registerMessageListener = function (onApply, onCancel, authenticate, preRender, onEvent) {
    var handleMessage = function (e) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ([
            "http://localhost:3000",
            "https://alpha.typeface.ai",
            "https://beta.typeface.ai",
            "https://app.typeface.ai",
            "https://orange-river-02396eb0f-preview.eastus2.2.azurestaticapps.net",
            "https://white-mud-09f09830f-preview.eastus2.2.azurestaticapps.net",
        ].includes(e.origin)) {
            if (((_a = e.data) === null || _a === void 0 ? void 0 : _a.type) === "tf-embed-event") {
                if (onEvent) {
                    onEvent(e.data.data.event);
                }
            }
            if (((_b = e.data) === null || _b === void 0 ? void 0 : _b.type) === "tf-embed-generated-content") {
                onApply(e.data.data || "");
            }
            if (((_c = e.data) === null || _c === void 0 ? void 0 : _c.type) === "tf-embed-cancel") {
                onCancel();
            }
            if (((_d = e.data) === null || _d === void 0 ? void 0 : _d.type) === "tf-embed-request-token") {
                if (authenticate) {
                    authenticate().then(function (token) {
                        var _a;
                        (_a = e.source) === null || _a === void 0 ? void 0 : _a.postMessage({ token: token }, { targetOrigin: e.origin });
                    });
                }
            }
            if (((_e = e.data) === null || _e === void 0 ? void 0 : _e.type) === "tf-pre-render") {
                if (preRender) {
                    console.log("pre-rendering", (_f = e.data.data) === null || _f === void 0 ? void 0 : _f.block);
                    preRender((_g = e.data.data) === null || _g === void 0 ? void 0 : _g.block).then(function (block) {
                        var _a;
                        (_a = e.source) === null || _a === void 0 ? void 0 : _a.postMessage({ block: block }, { targetOrigin: e.origin });
                    });
                }
                else {
                    // Not configured.. Send back same message without formatting.
                    (_h = e.source) === null || _h === void 0 ? void 0 : _h.postMessage(e.data, { targetOrigin: e.origin });
                }
            }
        }
    };
    window.addEventListener("message", handleMessage, false);
    return handleMessage;
};
export var shouldUsePopUpWindow = function () {
    var userAgent = navigator.userAgent;
    // Check if the browser is Chrome
    if (userAgent.indexOf("Chrome") !== -1 && userAgent.indexOf("Safari") !== -1) {
        // Chrome
        return false;
    }
    // Check if the browser is Safari
    else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
        // Safari
        return false;
    }
    // Check if the browser is Firefox
    else if (userAgent.indexOf("Firefox") !== -1) {
        // Firefox
        return false;
    }
    // Check if the browser is Edge (Chromium-based)
    else if (userAgent.indexOf("Edg") !== -1) {
        // Edge (Chromium-based)
        return false;
    }
    // Fallback for other browsers
    else {
        return false;
    }
};
